// Alle talen samen, voor de webapp, de API en de e-mails (golf 3, talen). De kiosk importeert dit
// NOOIT: die houdt alleen nl in de bundle en laadt de andere talen los van zijn eigen origin
// (pack.ts, apps/kiosk/src/i18n). Elke catalogus: nl + het taalbestand, wat ontbreekt uit nl.
import { appAr } from './app.ar.js';
import { appDe } from './app.de.js';
import { appEn } from './app.en.js';
import { appFr } from './app.fr.js';
import { appNl } from './app.nl.js';
import { appTr } from './app.tr.js';
import { ar } from './ar.js';
import { de } from './de.js';
import { emailAr } from './email.ar.js';
import { emailDe } from './email.de.js';
import { emailEn } from './email.en.js';
import { emailFr } from './email.fr.js';
import { emailNl } from './email.nl.js';
import { emailTr } from './email.tr.js';
import { en } from './en.js';
import { fr } from './fr.js';
import { LOCALES, normalizeLocale } from './locales.js';
import { mergeCatalog } from './merge.js';
import { nl } from './nl.js';
import { buildMessages } from './t.js';
import { tr } from './tr.js';
import { weatherPrayerAr } from './weatherPrayer.ar.js';
import { weatherPrayerDe } from './weatherPrayer.de.js';
import { weatherPrayerEn } from './weatherPrayer.en.js';
import { weatherPrayerFr } from './weatherPrayer.fr.js';
import { weatherPrayerNl } from './weatherPrayer.nl.js';
import { weatherPrayerTr } from './weatherPrayer.tr.js';
/** Taalbestanden per catalogus (nl is de basis; en is volledig, de rest groeit). */
export const LOCALE_SOURCES = {
    messages: { 'en-GB': en, 'tr-TR': tr, ar, 'de-DE': de, 'fr-FR': fr },
    app: {
        'en-GB': appEn,
        'tr-TR': appTr,
        ar: appAr,
        'de-DE': appDe,
        'fr-FR': appFr,
    },
    weatherPrayer: {
        'en-GB': weatherPrayerEn,
        'tr-TR': weatherPrayerTr,
        ar: weatherPrayerAr,
        'de-DE': weatherPrayerDe,
        'fr-FR': weatherPrayerFr,
    },
    email: {
        'en-GB': emailEn,
        'tr-TR': emailTr,
        ar: emailAr,
        'de-DE': emailDe,
        'fr-FR': emailFr,
    },
};
/** De Nederlandse basis per catalogus (voor het rapport van ontbrekende sleutels). */
export const BASE_CATALOGS = {
    messages: nl,
    app: appNl,
    weatherPrayer: weatherPrayerNl,
    email: emailNl,
};
/**
 * Alleen voor de platformbeheerder (AMUMIN Beheer, golf 4): de oprichter werkt in het Nederlands,
 * dus deze delen van de app-catalogus zijn nl/en. Andere talen vallen er netjes terug op nl; de
 * volledigheidstests (tr en fr) tellen ze niet mee. Alles wat een gezin ziet, hoort hier NIET.
 */
export const PLATFORM_ONLY_APP_KEYS = ['beheer', 'nav.beheer'];
const cache = {};
function cached(name, locale, build) {
    const key = `${name}:${locale}`;
    if (!(key in cache))
        cache[key] = build();
    return cache[key];
}
/** Bord- en algemene teksten (Messages) voor een taal; nl als terugval. */
export function messagesFor(locale) {
    const code = normalizeLocale(locale);
    if (code === 'nl-NL')
        return nl;
    if (code === 'en-GB')
        return en;
    return cached('messages', code, () => buildMessages(code, LOCALE_SOURCES.messages[code]));
}
function mergedFor(name, base, locale) {
    const code = normalizeLocale(locale);
    if (code === 'nl-NL')
        return base;
    const source = LOCALE_SOURCES[name][code];
    // en is volledig (het type dwingt dat af): dan het object zelf.
    if (code === 'en-GB')
        return source;
    return cached(name, code, () => mergeCatalog(base, source, code));
}
/** Teksten van de ouder-webapp voor een taal; valt terug op Nederlands. */
export function appMessagesFor(locale) {
    return mergedFor('app', appNl, locale);
}
/** Weer en gebedstijden (webapp en de voorgeformatteerde zinnen van de server). */
export function weatherPrayerFor(locale) {
    return mergedFor('weatherPrayer', weatherPrayerNl, locale);
}
/** E-mails in de taal van de ontvanger. */
export function emailMessagesFor(locale) {
    return mergedFor('email', emailNl, locale);
}
/** Alle talen behalve nl, in registervolgorde (voor het rapport en de kiosk-pakketten). */
export const TRANSLATED_LOCALES = LOCALES.filter((l) => l !== 'nl-NL');
//# sourceMappingURL=catalogs.js.map